module.exports = __webpack_public_path__ + "img/menu_njjd_c.82361f4e.png";